import Image from "next/image";
import style from "./style.module.scss";
import {Button} from "@/theme/ui";
import {UploadIcon} from "@/theme/assets/icons";
import {useTranslations} from "next-intl";


export const MainUploadButton = ({type = null}) =>{
    const t = useTranslations('media');
    return(
        <>
            <div className={style.main_upload_button_wrapper}>
                <div className={style.upload_button_content}>
                    <div className={style.icon}>
                        <Image
                            src={type === 'icon' ?
                                '/icon/image-plus.svg' :
                                    (type === 'image' ? '/icon/imagesSquare.svg' : '/icon/image.svg')}
                            alt={'image.svg'}
                            width="50"
                            height="50"
                        />
                    </div>
                    <div className={style.button}>
                        <Button
                            type={'primary'}
                            ghost
                            className={'button_icon'}
                            icon={<UploadIcon />}
                            style={{direction: 'rtl'}}
                        >
                            {type === 'image' ? t('photo') : t('icon')}
                        </Button>
                    </div>
                    {type !== null &&
                        <div className={style.desc}>
                            {t('drop')}
                        </div>
                    }
                </div>
            </div>
        </>
    )
}